import { Injectable } from "@angular/core";

import { TranslationHelperService } from "@nms-ng2/app/shared/services/util/translation-helper.service";
import {
    AbstractErrorResponseHandlerService
} from "@nms-ng2/app/core/services/error-response-handler/abstract-error-response-handler";
import {
    ErrorDescriptionDetails,
    ErrorResponse,
    NmsError,
} from "@nms-ng2/app/core/services/error-response-handler/error-response-handler.model";
import { ERROR_NAME } from "@nms-ng2/app/core/services/error-response-handler/error-names.constant";

/**
 * Serviço para lidar com mensagens de erros recebidas através de um @see ErrorResponse.
 */
@Injectable({
    providedIn: "root"
})
export class ErrorResponseHandlerService extends AbstractErrorResponseHandlerService {

    private readonly LOCALE_PREFIX: string = "response.error.";

    constructor(private readonly translationHelper: TranslationHelperService) {
        super(NmsError);
    }

    public buildErrorDescriptionDetails(errorResponse: ErrorResponse,
                                        detailsSeparator: string = "<br>",
                                        status?: number): ErrorDescriptionDetails {
        const { code, details } = errorResponse;
        const errorName = ERROR_NAME[code];

        if (!errorName) {
            const unknownError = this.translationHelper.translateByPrefix(this.LOCALE_PREFIX, "UNEXPECTED_ERROR");
            throw new Error(`${unknownError} ${code}`);
        }

        return {
            description: this.translationHelper.translateByPrefix(this.LOCALE_PREFIX, errorName),
            details: this.buildErrorDetails(code, details)
        };
    }

    public buildErrorDetails(code: number, details: Array<string>): string {
        let detailsMessage = this.getDefaultSeparator();

        if (details && details.length > 0) {
            detailsMessage += details.join(this.getDefaultSeparator());
        }

        return detailsMessage;
    }
}
